// Import necessary libraries
import React, { useState, useEffect } from 'react';
import '../Styles/Slider.css'; // Make sure this path is correct

// Banner slides with real person images - SEO-friendly file names
const slides = [
    { 
        id: 1, 
        title: "Educational Excellence", 
        subtitle: "Comprehensive Learning Solutions",
        description: "Empowering students with innovative educational programs and comprehensive learning experiences for academic success.",
        icon: "🎓",
        // Professional dark background with subtle blue accent
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #1e40af 100%)",
        overlay: "linear-gradient(135deg, rgba(15, 23, 42, 0.85) 0%, rgba(30, 41, 59, 0.75) 100%)",
        accentColor: "#3b82f6",
        image: "/educational-excellence.png",
        imagePosition: "right"
    },
    { 
        id: 2, 
        title: "Digital Transformation", 
        subtitle: "Modern Education Technology",
        description: "Empower universities to embrace digital transformation with cutting-edge technology solutions.",
        icon: "💻",
        // Sophisticated dark purple-blue gradient
        background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 50%, #4c1d95 100%)",
        overlay: "linear-gradient(135deg, rgba(30, 27, 75, 0.9) 0%, rgba(49, 46, 129, 0.8) 100%)",
        accentColor: "#8b5cf6",
        image: "/digital-transformation.png",
        imagePosition: "left"
    },
    { 
        id: 3, 
        title: "Student Life Management", 
        subtitle: "Complete Campus Solutions",
        description: "Digitalize every aspect of student life on campus with our comprehensive management platform.",
        icon: "🏫",
        // Professional dark teal-blue gradient
        background: "linear-gradient(135deg, #0c4a6e 0%, #075985 50%, #0369a1 100%)",
        overlay: "linear-gradient(135deg, rgba(12, 74, 110, 0.85) 0%, rgba(7, 89, 133, 0.75) 100%)",
        accentColor: "#0ea5e9",
        image: "/student-life-management.png",
        imagePosition: "left"
    },
    { 
        id: 4, 
        title: "Innovation in Learning", 
        subtitle: "Future-Ready Education",
        description: "Transform educational institutions with our state-of-the-art ERP and management systems.",
        icon: "🚀",
        // Modern dark green-blue gradient
        background: "linear-gradient(135deg, #064e3b 0%, #065f46 50%, #047857 100%)",
        overlay: "linear-gradient(135deg, rgba(6, 78, 59, 0.85) 0%, rgba(6, 95, 70, 0.75) 100%)",
        accentColor: "#10b981",
        image: "/innovation-in-learning.png",
        imagePosition: "right"
    },
];

const ImageSlider = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    // Automatic slider transition
    useEffect(() => {
        const slideInterval = setInterval(() => {
            setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
        }, 4000); // Change slide every 4 seconds

        return () => clearInterval(slideInterval); // Clear interval on component unmount
    }, []);

    return (
        <div className="slider-container">
            <div
                className="slider"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
                {slides.map((slide, index) => (
                    <div 
                        className={`slide ${index === currentSlide ? 'active' : ''} slide-image-${slide.imagePosition}`}
                        key={slide.id}
                        style={{ 
                            background: slide.background,
                            '--accent-color': slide.accentColor
                        }}
                    >
                        {/* Overlay for better text readability */}
                        <div 
                            className="slide-overlay"
                            style={{ background: slide.overlay }}
                        />
                        
                        {/* Animated background shapes */}
                        <div className="slide-background-shapes">
                            <div className="shape shape-1" />
                            <div className="shape shape-2" />
                            <div className="shape shape-3" />
                        </div>
                        
                        <div className={`slide-content slide-content-${slide.imagePosition}`}>
                            <div className="slide-title-container">
                                <div className="slide-icon">{slide.icon}</div>
                                <h1 className="slide-title">{slide.title}</h1>
                            </div>
                            <h2 className="slide-subtitle">{slide.subtitle}</h2>
                            <p className="slide-description">{slide.description}</p>
                        </div>
                        <div className={`slide-image-wrapper slide-image-wrapper-${slide.imagePosition}`}>
                            {slide.image ? (
                                <div className="slide-image-container">
                                    <div className="slide-image-glow" />
                                    <img 
                                        src={slide.image} 
                                        alt={slide.title}
                                        className="slide-image"
                                        loading="lazy"
                                    />
                                </div>
                            ) : (
                                <div className="placeholder-message">
                                    <p>Image placeholder - Add real person image</p>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            
            {/* Navigation dots */}
            <div className="slider-dots">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        className={`dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => setCurrentSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
            
            {/* Progress bar */}
            <div className="slider-progress">
                <div 
                    className="slider-progress-bar"
                    style={{ 
                        width: `${((currentSlide + 1) / slides.length) * 100}%`,
                        transition: 'width 0.3s ease'
                    }}
                />
            </div>
        </div>
    );
};

export default ImageSlider;
